/*
 * PROD-7828 R10 — audit-trail browser: filter state and request builders. Pure (no React, no I/O)
 * so the request contract (reports_enums.json request_fields_read) is pinned by unit tests.
 */
import { build_query_string } from '../overview/params';

// reports_enums.json limits.audit_limit_default; the server caps a page at 200.
export const AUDIT_PAGE_SIZE = 100;

const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;
// A deep link carries whatever was typed into the URL; only a uuid-shaped value is sent.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const valid_audit_month = (v) => typeof v === 'string' && MONTH_RE.test(v);

export const blank_audit_filters = (pay_month = '') => ({
  pay_month: valid_audit_month(pay_month) ? pay_month : '',
  teacher_uuid: '',
  teacher_name: '',
  entity_type: '',
  action: '',
  actor: ''
});

// ?pay_month=YYYY-MM&teacher_uuid=… (Overview L2 "All activity this month"); anything else is dropped.
export const parse_audit_deep_link = (search) => {
  const qs = new URLSearchParams(search || '');
  const pay_month = (qs.get('pay_month') || '').trim();
  const teacher_uuid = (qs.get('teacher_uuid') || '').trim();
  return {
    pay_month: valid_audit_month(pay_month) ? pay_month : '',
    teacher_uuid: UUID_RE.test(teacher_uuid) ? teacher_uuid : ''
  };
};

// The server refuses a request with neither (AUDIT_FILTER_REQUIRED); the UI never sends one.
export const has_audit_scope = (f) => !!(f && (f.pay_month || f.teacher_uuid));

// Month or teacher changed: the entity/action/actor facets are re-read, so their picks reset.
export const with_scope = (f, patch) => ({
  ...f,
  ...patch,
  entity_type: '',
  action: '',
  actor: ''
});

const scope = (f) => ({ pay_month: f.pay_month, teacher_uuid: f.teacher_uuid });

const narrowing = (f) => ({
  ...scope(f),
  entity_type: f.entity_type,
  action: f.action,
  actor: f.actor
});

export const audit_facets_params = (f) => scope(f);

// before_id: the previous page's next_before_id (keyset, newest first); '' for the first page.
export const audit_list_params = (f, before_id = '') => ({
  ...narrowing(f),
  before_id: before_id || '',
  limit: AUDIT_PAGE_SIZE
});

export const audit_csv_params = (f) => narrowing(f);

// Overview L2's link into the browser, scoped to one teacher-month.
export const audit_link = (pay_month, teacher_uuid) =>
  `/teacher-payments/audit?${build_query_string({ pay_month, teacher_uuid })}`;

// Used when the server sends no usable Content-Disposition name (absent, unexposed or unsafe).
export const audit_csv_fallback_name = (f) =>
  `teacher_payments_audit_${f.pay_month || 'all_months'}${f.teacher_uuid ? `_${f.teacher_uuid.slice(-8)}` : ''}.csv`;
